import {Image, makeStorageUrl} from 'platform/foundation';

import {isNil} from 'ramda';

interface SellerPhotoProps {
  photoUrl: string | null;
  ownerName: string;
}

const SELLER_PHOTO_SIZE = 18;
const SELLER_PHOTO_SOURCE_SIZE = 144;

export function SellerPhoto(props: SellerPhotoProps) {
  if (isNil(props.photoUrl)) {
    return null;
  }

  return (
    <Image
      src={makeStorageUrl(
        props.photoUrl,
        SELLER_PHOTO_SOURCE_SIZE,
        SELLER_PHOTO_SOURCE_SIZE,
        'cover'
      )}
      alt={props.ownerName}
      width={SELLER_PHOTO_SIZE}
      height={SELLER_PHOTO_SIZE}
      minWidth={SELLER_PHOTO_SIZE}
      fit="cover"
      position="center"
      borderRadius="small"
    />
  );
}
